var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "checked";
},"3":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div id=\"fr-results-lbl\">Results</div>\n\n<div id=\"fr-result-show-by-rbs\">\n\n    <label>\n        <input id=\"fr-show-by-page\" class=\"fr-show-by-rb\" type=\"radio\" name=\"page_or_search\" value=\"PAGE\" title=\"Show results by page\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showResultsByPage : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n               title=\"View By Page\">\n        Page\n    </label>\n\n    <label>\n        <input id=\"fr-show-by-search\" class=\"fr-show-by-rb\" type=\"radio\" name=\"page_or_search\" value=\"SEARCH\" title=\"Show results by search\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showResultsBySearch : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n               title=\"View By Search\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableShowResultsBySearch : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n        Search\n    </label>\n\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/resultsHeader/template.hbs
 ** module id = 645
 ** module chunks = 0
 **/